import { useEffect, useMemo, useState } from 'react';
import { ChevronLeft, ChevronRight, ChevronsLeft, ChevronsRight, FileText, ClipboardPlus, ClipboardList, ChevronDown, FileClock } from 'lucide-react';
import { Progress } from 'antd';
import Icons from '../../../assets/icons';
import useCustomToast from '../../../hooks/useCustomToast';
import { CONFIG } from '../../../config';
import axios from 'axios';
import GenericStatusComponent from '../../../genericComponents/GenericStatusComponent';
import ParentModal from '../../../genericComponents/ParentModal';
import TrfModal from './TrfModal';
import FullPageLoader from '../../../loaders/FullPageLoader';
import SessionExpiredModal from '../../../authComponents/login/sessionExpired/SessionExpiredModal';
import ReportUploadModal from './ReportUploadModal';
import LoginStack from '../../../authComponents/login/LoginStack';
import GenericMediaViewModal from '../../../genericComponents/media/GenericMediaViewModal';
import { getFileNameFromExt, getFileTypeFromUrl } from '../../../helper/helperTableFunctions';

const tableHeaders = [{ key: 'trfCode', name: 'TRF Number' }, { key: 'vendorName', name: 'Vendor Name' }, { key: 'orderNumber', name: 'PO Number' }, { key: 'fptStatus', name: 'FPT Status' }, { key: 'gptStatus', name: 'GPT Status' }, { key: 'division', name: 'Division' }, { key: 'designNo', name: 'Design' }, { key: 'department', name: 'Department' }, { key: 'report', name: 'Report' }]
const TRFListsEmail = () => {
    const [trfListingData, setTrfListingData] = useState({})
    const [loading, setLoading] = useState(true)
    const [itemsPerPage, setItemsPerPage] = useState(10);
    const [totalItems, setTotalItems] = useState(0);
    const [maxPage, setMaxPage] = useState(1);
    const [selectPage, setSelectPage] = useState(false);
    const customToast = useCustomToast()
    const [selectedModal, setSelectedModal] = useState(false);
    const [emailToken, setEmailToken] = useState(null)
    const [labEmail, setLabEmail]= useState(null)
    const [trfModalData, setTrfModalData] = useState({})
    const [dataForReportModal, setDataForReportModal] = useState({
        dropdown1Status: null,
        dropdown2Status: null,
        code: null,
        text1Data: null,
        text2Data: null,
        report1: null,
        report2: null,
    })
    const [currentPage, setCurrentPage] = useState(1);
    const [viewFormOnly, setViewFormOnly] = useState(true)
    const [emailTrfCode, setEmailTrfCode] = useState(null)
    const [needsLogin, setNeedsLogin] = useState(false);
    const [testTrfData, setTestTrfData] = useState({})
    const [justFormVisible, setJustFormVisible] = useState(false)
    const [viewReport, setViewReport] = useState({
        gptDocument: null,
        fptDocument: null
    })
    const [openFilterDropdown, setOpenFilterDropdown] = useState(null);
    const [filterSelections, setFilterSelections] = useState({ fptStatus: [], gptStatus: [] });
    const [committedSelections, setCommittedSelections] = useState({ fptStatus: [], gptStatus: [] });
    const [dropdownPos, setDropdownPos] = useState({ top: 0, left: 0 });
    const [textFilters, setTextFilters] = useState({});
    const [committedFilters, setCommittedFilters] = useState({});
    const [globalSearch, setGlobalSearch] = useState("");
    const [committedGlobalSearch, setCommittedGlobalSearch] = useState("");

    useEffect(() => {
        const hash = window.location.hash; // "#/email/getAll/trf?emailToken=xxx&labEmail=xxx or #/email/getForm?trfCode=xxx&emailToken=xxx"

        const hasQuery = hash.includes("?");
        let urlToken = null;
        let trfCode = null;
        let labEmail = null;
        if (!hasQuery) {
            setNeedsLogin(true)
            return;
        }

        if (hasQuery) {
            const [path, query] = hash.split("?");
            urlToken = new URLSearchParams(query).get("emailToken");
            
            if (path.includes("email/getForm")) {
                trfCode = new URLSearchParams(query).get("trfCode");
                if (!trfCode) {
                    setNeedsLogin(true)
                    return;
                }
                setJustFormVisible(true)
                setViewFormOnly(true)
                setEmailTrfCode(trfCode)
                setLabEmail(null)
            } else {
                labEmail = new URLSearchParams(query).get("labEmail");
                if (!labEmail) {
                    setNeedsLogin(true)
                    return;
                }
                setLabEmail(labEmail)
                setJustFormVisible(false)
                setViewFormOnly(false)
                setEmailTrfCode(null)
            }


            if (urlToken) {
                sessionStorage.setItem("emailToken", urlToken);
                setEmailToken(urlToken);
                if (trfCode) {
                    window.location.hash = `${path}?trfCode=${trfCode}`
                }
                else window.location.hash =`${path}?labEmail=${labEmail}`; // removes ?emailToken
                return;
            }
        }
        if (hash.includes('email/getAll/trf')) {
            setJustFormVisible(false)
            setViewFormOnly(false);
            setEmailTrfCode(null);
        }
        const stored = sessionStorage.getItem("emailToken");
        setEmailToken(stored);
        if (!stored) {
            setSelectedModal("sessionModal")
        }
    }, [])

    const getTheTestData = async () => {
        try {
            const testArray = [
                "TRF_CARE_INSTRUCTIONS",
                "TRF_FPT_TEST",
                "TRF_GPT_TEST",
                "TRF_ADDITIONAL_TEST",
            ]
            const res = await Promise.allSettled(testArray.map(type => axios.get(`${CONFIG.BASE_URL}/core/dropdown/get?type=${type}`, {
                headers: {
                    "X-Auth-Token": emailToken,
                    'X-Scope-Id': "common.commonfunctionality.view"
                }
            })))
            const testData = res.reduce((acc, item, idx) => {
                const key = testArray[idx];

                if (item.status === "fulfilled") {
                    acc[key] = item.value?.data?.data?.resource || [];
                } else {
                    acc[key] = [];
                }

                return acc;
            }, {});

            setTestTrfData(testData)
        } catch (e) {
            console.log(e)
            setTestTrfData({})
        }
    }

    const handleChange = async (type, item) => {
        switch (type) {
            case "viewTrf":
                try {
                    setLoading(true)
                    const res = await axios.post(`${CONFIG.SM_BACKEND_BASE_URL}/purchase/order/view/trf/data`, { trfCode: item?.trfCode }, {
                        headers: {
                            "X-Auth-Token": emailToken,
                            'X-Scope-Id': "vendor.purchase.trf.view"
                        }
                    })
                    if (res?.status === 200 && res?.data?.error?.errorCode === "4000") {
                        setSelectedModal("sessionModal")
                        return;
                    }
                    const fieldsToFix = [
                        "additionalTestRequired",
                        "packageTestGPT",
                        "packageTestFPT",
                        "careInstructions"
                    ];
                    const cleanedRes = { ...res?.data?.data };
                    fieldsToFix.forEach(field => {
                        if (cleanedRes[field] == null) {
                            cleanedRes[field] = [];
                        }
                    });
                    const data = {
                        [cleanedRes?.designNo]: cleanedRes
                    };
                    await getTheTestData()
                    setSelectedModal("viewTRFModal");
                    setTrfModalData(data)
                } catch (e) {
                    customToast({
                        type: "error",
                        message: e?.message || "Something went wrong",
                    })
                } finally {
                    setLoading(false)
                }
                break;
            case "uploadReport":
                setSelectedModal("uploadReportModal")
                setDataForReportModal({
                    dropdown1Status: item?.fptStatus,
                    dropdown2Status: item?.gptStatus,
                    code: item?.trfCode,
                    report1: item?.fptDocument,
                    report2: item?.gptDocument,
                    text1: item?.fptRemarks,
                    text2: item?.gptRemarks
                })
                break;
            case "openMediaViewModal":
                setViewReport({
                    fptDocument: item?.fptDocument,
                    gptDocument: item?.gptDocument
                })
                setSelectedModal("openMediaViewModal")
        }

    };

    const summaryData = useMemo(() => {
        const totalTRF = trfListingData?.resource?.length || 0;
        const totalPass = trfListingData?.resource?.filter(item => (item.fptStatus?.toUpperCase() === "PASSED" || item.fptStatus?.toUpperCase() === "FAILED") && (item.gptStatus?.toUpperCase() === "PASSED" || item.gptStatus?.toUpperCase() === "FAILED")).length || 0;
        return {
            totalTRF,
            totalPass,
        }
    }, [trfListingData])

    const fetchTrfData = async () => {
        try {
            setLoading(true)
            const filterPayload = {};
            Object.keys(committedFilters).forEach(key => {
                if (committedFilters[key]?.trim()) filterPayload[key] = committedFilters[key].trim();
            });
            Object.keys(committedSelections).forEach(key => {
                if (committedSelections[key]?.length) filterPayload[key] = committedSelections[key];
            });
            const res = await axios.post(`${CONFIG.SM_BACKEND_BASE_URL}/purchase/order/get/all/trf/data`, {
                "type": 1,
                "pageNo": currentPage,
                "pageSize": itemsPerPage,
                "sortedBy": "",
                "sortedIn": "",
                "search": committedGlobalSearch,
                "filter": filterPayload,
                "status": "ALL_STATUS",
                "isDashboardComment": 0,
                "displayName": "ENT_TRF_DATA",
                "labEmail": JSON.parse(labEmail)
            }, {
                headers: {
                    'X-Auth-Token': emailToken,
                    'X-Scope-Id': "common.commonfunctionality.view"
                },

            })

            if (res?.status === 200 && res?.data?.error?.errorCode === "4000") {
                setSelectedModal("sessionModal")
                return;
            }
            setTrfListingData(res?.data?.data)
            setTotalItems(res?.data?.data?.totalRecord || 0);
            setMaxPage(res?.data?.data?.maxPage || 1);
        } catch (e) {
            customToast({
                type: "error",
                message: e?.message || "Something went wrong",
            })
        } finally {
            setLoading(false)
        }
    }

    useEffect(() => {
        if (!emailToken) {
            return
        }
        if (!viewFormOnly) fetchTrfData()
        else handleChange("viewTrf", { trfCode: emailTrfCode })
    }, [emailToken, currentPage, itemsPerPage, viewFormOnly, committedFilters, committedSelections, committedGlobalSearch])

    const getChildComponent = () => {
        switch (selectedModal) {
            case "viewTRFModal":
                return TrfModal
            case "sessionModal":
                return SessionExpiredModal;
            case "uploadReportModal":
                return ReportUploadModal;
            case "openMediaViewModal":
                return GenericMediaViewModal;
        }
    }

    const getParentChildProps = () => {
        let payload = {
            closeModal: () => {
                setSelectedModal(false);
            },
            animationType: "bottom",
            parentModalOuterMostClassName: "flex items-center justify-center",
            postitionProps: { position: "relative" },
            dimensions: {
                width: "84%",
                height: "80%",
                maxHeight: "700px",
                maxWidth: "1250px",
            },
        };
        switch (selectedModal) {
            case "viewTRFModal":
                return {
                    ...payload,
                    closeModal: () => {
                        setSelectedModal(false);
                        setTrfModalData({});
                    },
                    modalHeading: "TRF Details",
                    trfData: trfModalData,
                    viewTrfMode: true,
                    testTrfData: testTrfData,
                    justFormVisible: justFormVisible,
                    isCloseBlocked: justFormVisible,
                    dimensions: {
                        width: "84%",
                        maxWidth: "1200px",
                        height: "90vh",
                        maxHeight: "800px",
                        overflow: "auto"
                    }
                }
            case "sessionModal":
                return {
                    ...payload,
                    closeModal: () => {
                        setSelectedModal("sessionModal");
                    },
                    modalHeading: "Session Expired",
                    emailTokenExpire: true,
                    dimensions: {
                        width: "84%",
                        maxWidth: "700px",
                        height: "90vh",
                        maxHeight: "350px",
                        overflow: "auto"
                    }
                }
            case "uploadReportModal":
                return {
                    ...payload,
                    closeModal: () => {
                        setSelectedModal(false);
                        setDataForReportModal({
                            dropdown1Status: null,
                            dropdown2Status: null,
                            code: null,
                            report1: null,
                            report2: null,
                            text1: null,
                            text2: null
                        });
                        fetchTrfData()
                    },
                    modalHeading: "Upload Report",
                    data: {
                        heading: "Submit Report(FPT & GPT)",
                        details: dataForReportModal,
                        dropdown1: {
                            label: "FPT Status",
                            options: [{ key: "passed", value: "Passed" }, { key: "failed", value: "Failed" }, { key: "hold", value: "Hold" }],
                            required: false,
                        },
                        dropdown2: {
                            label: "GPT Status",
                            options: [{ key: "passed", value: "Passed" }, { key: "failed", value: "Failed" }, { key: "hold", value: "Hold" }],
                            required: false,
                        },
                        textArea1: {
                            label: "FPT Remark",
                            required: false,
                        },
                        textArea2: {
                            label: "GPT Remark",
                            required: false,
                        },
                        upload: {
                            label: "Attach Report",
                            supportedFileTypes: ["PDF", "XLSX", "CSV", "JPEG", "PNG", "JPG"],
                            maxSizeSupported: "10MB",
                        },
                        checkbox: {
                            label: "I Accept that Report statuses or file cannot be edited or re-uploaded once submitted.",
                            required: true,
                            value: true
                        },
                        submission: {
                            API: "purchase/order/lab/report/submit",
                            BACKEND_BASE_URL: CONFIG.SM_BACKEND_BASE_URL,
                            token: emailToken,
                            scopeId: "common.commonfunctionality.view"
                        }
                    },
                    dimensions: {
                        width: "84%",
                        maxWidth: "800px",
                        overflow: "auto",
                        height: "fit-content"
                    }
                }
            case "openMediaViewModal":
                const gptExt = getFileTypeFromUrl(viewReport?.gptDocument)
                const mediaTypeGPT = getFileNameFromExt(gptExt)
                const fptExt = getFileTypeFromUrl(viewReport?.fptDocument)
                const mediaTypeFPT = getFileNameFromExt(fptExt)
                return {
                    ...payload,
                    onClose: () => {
                        setSelectedModal(null)
                        setViewReport({
                            fptDocument: null,
                            gptDocument: null
                        })
                    },
                    parentModalOuterMostClassName: 'flex items-center justify-center',
                    postitionProps: { position: 'relative' },
                    dimensions: { width: "100vw", height: "100vh", backgroundColor: 'transparent' },
                    filesData: [
                        {
                            fileUrl: viewReport?.fptDocument || "",
                            fileType: mediaTypeFPT,
                            name: "FPT Document"
                        },
                        {
                            fileUrl: viewReport?.gptDocument || "",
                            fileType: mediaTypeGPT,
                            name: "GPT Document"
                        }
                    ]
                }
        }
    }
    if (needsLogin) {
        return <LoginStack />
    }
    else if (loading && selectedModal !== "sessionModal") {
        return <FullPageLoader style={{ opacity: 0.5 }} />
    }
    return (
        <div className='completeProductSurvey h-screen overflow-hidden flex flex-col text-fontBlack font-poppins'>
            {!viewFormOnly && (
                <div className='flex flex-col h-full overflow-hidden'>
                    {/* Fixed Top Section: Logo + Summary + Progress / Search / Pagination */}
                    <div className='flex-none bg-white z-[100] shadow-[0px_4px_20px_-16px_#8B93BB]'>
                        {/* Logo Header */}
                        <div className='px-4 py-3 flex items-center justify-between gap-4 w-full'>
                            <div className='sfmi-head'>
                                <Icons.SupplymintRIcon />
                            </div>
                        </div>

                        {/* Summary Section */}
                        <div className='bg-[#F3F4F9] px-4 py-3 space-y-3'>
                            <div className='bg-white px-4 py-3 w-full flex items-center justify-between gap-4 shadow-sm rounded-lg'>
                                <section className='flex gap-2 items-center'>
                                    <p className='mb-0 text-lg font-semibold flex items-center gap-1.5'><ClipboardList size={21} color="#5D5FEF" /> Test Report Forms Received</p>
                                    <p className='mb-0 px-2 py-1 w-fit text-[12px] font-medium rounded-full bg-primary_w_less_opacity border border-primaryLight ml-4'>{summaryData?.totalTRF} TRFS</p>
                                </section>
                            </div>
                        </div>

                        {/* Progress, Search, and Pagination Section */}
                        <div className="bg-gray-50 p-6">
                            <div className="w-full flex items-center justify-between gap-4 px-4 mb-4">
                                <div className="px-4 flex items-center gap-2">
                                    <Progress className={`timerProgress ${true ? 'timeStarted' : ''}`} steps={15} trailColor='#DAE4EE' strokeLinecap='round' percent={(summaryData?.totalPass / summaryData?.totalTRF) * 100} size={{ height: '25px', width: '5px' }} showInfo={false} />
                                    <span className="bg-[#FF5252] text-white text-xs font-bold px-3 py-1 rounded-full">
                                        {summaryData?.totalPass} of {summaryData?.totalTRF} Completed
                                    </span>
                                </div>

                                <div className="flex items-center gap-3 justify-end flex-1">
                                    <div className="relative flex-1 max-w-[238px]">
                                        <input
                                            type="text"
                                            placeholder="Search"
                                            value={globalSearch}
                                            onChange={(e) => {
                                                setGlobalSearch(e.target.value);
                                                if (e.target.value === '') {
                                                    setCommittedGlobalSearch('');
                                                }
                                            }}
                                            onKeyDown={(e) => {
                                                if (e.key === 'Enter') {
                                                    setCommittedGlobalSearch(globalSearch);
                                                    setCurrentPage(1);
                                                }
                                            }}
                                            className="w-full text-[13px] bg-white border border-[#DAE4EE] pl-7 pr-10 py-1.5 rounded-md focus:outline-none focus:ring-1 focus:ring-blue-500 placeholder:text-gray-400"
                                        />
                                        <Icons.SearchIcon
                                            className="absolute left-8 top-1/2 -translate-y-1/2 text-[#AEAEB0] cursor-pointer"
                                            height={13} width={13}
                                            onClick={() => {
                                                setCommittedGlobalSearch(globalSearch);
                                            }}
                                        />
                                        {globalSearch && (
                                            <button
                                                onClick={() => {
                                                    setGlobalSearch("");
                                                    setCommittedGlobalSearch("");
                                                    setCurrentPage(1);
                                                }}
                                                className="absolute right-8 top-1/2 -translate-y-1/2 text-gray-400 hover:text-gray-600 bg-gray-300 rounded-full p-5"
                                            >
                                                <Icons.ClearSearch height={7} width={7} />
                                            </button>
                                        )}
                                    </div>

                                    <div className="flex items-center gap-4">
                                        <div className="relative">
                                            <button
                                                className="flex items-center gap-2 text-sm font-medium text-gray-600 bg-white border border-gray-300 px-3 py-1.5 rounded-md hover:bg-gray-50"
                                                onClick={() => setSelectPage(!selectPage)}
                                            >
                                                <span className="font-semibold text-gray-900">{totalItems > itemsPerPage ? itemsPerPage : totalItems}</span> of <span className="font-semibold text-gray-900">{totalItems}</span> Items
                                                <ChevronDown size={16} />
                                            </button>
                                            {selectPage && (
                                                <div className="absolute bottom-full mb-1 left-0 w-full bg-white border border-gray-300 rounded-md shadow-lg" style={{zIndex: 1000}}>
                                                    {[10, 15, 20].map(size => (
                                                        <button
                                                            key={size}
                                                            className="block w-full text-left px-3 py-1.5 text-sm hover:bg-gray-100"
                                                            onClick={() => {
                                                                setItemsPerPage(size);
                                                                setCurrentPage(1);
                                                                setSelectPage(false);
                                                            }}
                                                        >
                                                            {size}
                                                        </button>
                                                    ))}
                                                </div>
                                            )}
                                        </div>

                                        <div className="h-6 w-px bg-gray-300"></div>

                                        <div className="flex items-center gap-2">
                                            <button
                                                className="p-1.5 border border-gray-300 rounded-md hover:bg-gray-50 disabled:opacity-50 disabled:cursor-not-allowed"
                                                onClick={() => setCurrentPage(1)}
                                                disabled={currentPage === 1}
                                            >
                                                <ChevronsLeft size={16} className="text-gray-600" />
                                            </button>
                                            <button
                                                className="p-1.5 border border-gray-300 rounded-md hover:bg-gray-50 disabled:opacity-50 disabled:cursor-not-allowed"
                                                onClick={() => setCurrentPage(prev => Math.max(prev - 1, 1))}
                                                disabled={currentPage === 1}
                                            >
                                                <ChevronLeft size={16} className="text-gray-600" />
                                            </button>

                                            <span className="text-sm font-medium text-gray-700 px-2">
                                                {currentPage} of {maxPage}
                                            </span>

                                            <button
                                                className="p-1.5 border border-gray-300 rounded-md hover:bg-gray-50 disabled:opacity-50 disabled:cursor-not-allowed"
                                                onClick={() => setCurrentPage(prev => Math.min(prev + 1, maxPage))}
                                                disabled={currentPage === maxPage}
                                            >
                                                <ChevronRight size={16} className="text-gray-600" />
                                            </button>
                                            <button
                                                className="p-1.5 border border-gray-300 rounded-md hover:bg-gray-50 disabled:opacity-50 disabled:cursor-not-allowed"
                                                onClick={() => setCurrentPage(maxPage)}
                                                disabled={currentPage === maxPage}
                                            >
                                                <ChevronsRight size={16} className="text-gray-600" />
                                            </button>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>

                    {/* Scrollable Table Section */}
                    <div className="flex-1 overflow-auto bg-gray-50 px-4 pb-6">
                        <table className="w-full mx-auto bg-white shadow font-medium border-separate border-spacing-0">
                            <thead className="bg-gray-50 sticky top-0 z-[110]">
                                <tr className="border-t border-b border-gray-200">
                                    {tableHeaders.map((item, index) => (
                                        <th
                                            key={item.key}
                                            className={`px-6 py-3 text-left text-xs font-medium text-gray-500 whitespace-nowrap min-w-[150px] tracking-wider border-r border-b border-borderSlateGrey last:border-r-0 ${index === 0 ? "sticky left-0 z-[120] bg-gray-50 shadow-[2px_0_5px_-2px_rgba(0,0,0,0.1)]" : ""}`}
                                        >
                                            {item.name}
                                        </th>
                                    ))}
                                </tr>
                                <tr className="bg-white border-b border-gray-200">
                                    {tableHeaders.map((item, index) => (
                                        <th
                                            key={item.key + '_filter'}
                                            className={`border-r border-b border-borderSlateGrey last:border-r-0 ${item.key === 'report' ? 'p-0 bg-gray-100' : 'px-4 py-2'} ${index === 0 ? "sticky left-0 z-[120] bg-white shadow-[2px_0_5px_-2px_rgba(0,0,0,0.1)]" : ""}`}
                                        >
                                            {item.key === 'fptStatus' || item.key === 'gptStatus' ? (
                                                <div className="relative w-full">
                                                    <button
                                                        type="button"
                                                        onClick={(e) => {
                                                            const rect = e.currentTarget.getBoundingClientRect();
                                                            setDropdownPos({ top: rect.bottom + 4, left: rect.right - 130});
                                                            setOpenFilterDropdown(openFilterDropdown === item.key ? null : item.key);
                                                        }}
                                                        className="w-full flex items-center justify-between gap-2 text-xs px-1 py-1.5 bg-transparent text-[#8496A9] font-semibold focus:outline-none whitespace-nowrap border-0"
                                                    >
                                                        <span className={`semibold ${filterSelections[item.key]?.length ? 'text-fontBlack' : ''}`}>
                                                            {filterSelections[item.key]?.length ? `${filterSelections[item.key].length} selected` : 'Select Options'}
                                                        </span>
                                                        <ChevronDown size={13} className="shrink-0 text-[#8496A9]" />
                                                    </button>
                                                    {openFilterDropdown === item.key && (
                                                        <>
                                                            <div style={{ position: 'fixed', inset: 0, zIndex: 9998 }} onClick={() => setOpenFilterDropdown(null)} />
                                                            <div
                                                                style={{ position: 'fixed', top: dropdownPos.top, left: dropdownPos.left, zIndex: 9999, width: '200px' }}
                                                                className="bg-white rounded-lg shadow-xl"
                                                            >
                                                                <div className="py-1">
                                                                    {['PASSED', 'FAILED', 'HOLD', 'PENDING', 'NA'].map(opt => (
                                                                        <label
                                                                            key={opt}
                                                                            className="flex items-center gap-2 px-2 py-1 hover:bg-[#F8FAFC] cursor-pointer w-full"
                                                                            onClick={() => {
                                                                                setFilterSelections(prev => {
                                                                                    const cur = prev[item.key] || [];
                                                                                    return { ...prev, [item.key]: cur.includes(opt) ? cur.filter(v => v !== opt) : [...cur, opt] };
                                                                                });
                                                                            }}
                                                                        >
                                                                            <span
                                                                                style={{
                                                                                    width: 15, height: 15, minWidth: 15,
                                                                                    border: '2px solid #CBD5E1',
                                                                                    borderRadius: 4,
                                                                                    backgroundColor: filterSelections[item.key]?.includes(opt) ? '#3B82F6' : '#fff',
                                                                                    borderColor: filterSelections[item.key]?.includes(opt) ? '#3B82F6' : '#CBD5E1',
                                                                                    display: 'flex', alignItems: 'center', justifyContent: 'center',
                                                                                }}
                                                                            >
                                                                                {filterSelections[item.key]?.includes(opt) && (
                                                                                    <svg width="11" height="8" viewBox="0 0 11 8" fill="none">
                                                                                        <path d="M1 3.5L4 6.5L10 1" stroke="white" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
                                                                                    </svg>
                                                                                )}
                                                                            </span>
                                                                            <span className="text-xs text-[#8496A9] font-semibold">{opt}</span>
                                                                        </label>
                                                                    ))}
                                                                </div>
                                                                <div className="px-4 py-1 border-t border-gray-100">
                                                                    <button
                                                                        type="button"
                                                                        onClick={() => {
                                                                            setCommittedSelections(prev => ({ ...prev, [item.key]: filterSelections[item.key] || [] }));
                                                                            setOpenFilterDropdown(null);
                                                                        }}
                                                                        className="text-xs font-semibold py-1.5 px-2 bg-gray-100 hover:bg-gray-200 rounded-md text-gray-700"
                                                                    >
                                                                        Done
                                                                    </button>
                                                                </div>
                                                            </div>
                                                        </>
                                                    )}
                                                </div>
                                            ) : item.key === 'report' ? (
                                                <div className="w-full h-full" />
                                            ) : (
                                                <div className="flex items-center justify-between gap-2">
                                                    <input
                                                        type="text"
                                                        placeholder="Value"
                                                        value={textFilters[item.key] || ''}
                                                        onChange={(e) => {
                                                            setTextFilters(prev => ({ ...prev, [item.key]: e.target.value }));
                                                            if (e.target.value === '') {
                                                                setCommittedFilters(prev => ({ ...prev, [item.key]: '' }));
                                                            }
                                                        }}
                                                        onKeyDown={(e) => {
                                                            if (e.key === 'Enter') {
                                                                setCommittedFilters(prev => ({ ...prev, [item.key]: textFilters[item.key] || '' }));
                                                            }
                                                        }}
                                                        className={`w-full text-xs font-semibold bg-transparent border-0 outline-none placeholder:text-[#94A3B8] placeholder:font-semibold ${committedFilters[item.key] ? 'text-fontBlack' : 'text-[#94A3B8]'}`}
                                                    />
                                                    {textFilters[item.key] ? (
                                                        <Icons.ClearSearch
                                                            className="text-gray-400 hover:text-gray-600 bg-gray-300 rounded-full p-5 cursor-pointer"
                                                            height={17} width={17}
                                                            onClick={() => {
                                                                setTextFilters(prev => ({ ...prev, [item.key]: '' }));
                                                                setCommittedFilters(prev => ({ ...prev, [item.key]: '' }));
                                                            }}
                                                        />
                                                    ) : (
                                                        <Icons.SearchIcon
                                                            className="text-[#94A3B8] shrink-0 cursor-pointer"
                                                            height={14} width={14}
                                                            onClick={() => {
                                                                setCommittedFilters(prev => ({ ...prev, [item.key]: textFilters[item.key] || '' }));
                                                            }}
                                                        />
                                                    )}
                                                </div>
                                            )}
                                        </th>
                                    ))}
                                </tr>
                            </thead>
                            <tbody className="bg-white divide-y divide-gray-200">
                                {trfListingData?.resource?.map((item, index) => (
                                    <tr key={index} className="hover:bg-gray-50">
                                        {tableHeaders?.map((tableData, idx) => (
                                            <td
                                                key={idx}
                                                className={`px-6 py-1.5 whitespace-nowrap text-left text-[12px] font-medium border-r border-b border-borderSlateGrey last:border-r-0 ${idx === 0 ? "sticky left-0 z-10 bg-white shadow-[2px_0_5px_-2px_rgba(0,0,0,0.1)]" : ""}`}
                                            >
                                                {tableData.key === "trfCode" ? (
                                                    <div className="flex items-center gap-2 cursor-pointer" onClick={() => handleChange("viewTrf", item)}>
                                                        <FileText size={21} color='gray'/>
                                                        <span className="text-blue-600 font-medium" style={{ textDecoration: "underline", }}>
                                                            {item.trfCode || "trfCode"}
                                                        </span>
                                                    </div>
                                                ) : tableData.key === "fptStatus" ? (
                                                    <GenericStatusComponent status={item.fptStatus} />
                                                ) : tableData.key === "gptStatus" ? (
                                                    <GenericStatusComponent status={item.gptStatus} />
                                                ) : tableData.key === "report" ? (
                                                    (item.fptStatus?.toUpperCase() === "PASSED" || item.fptStatus?.toUpperCase() === "FAILED" ||  item.fptStatus?.toUpperCase() === "NA") && (item.gptStatus?.toUpperCase() === "PASSED" || item.gptStatus?.toUpperCase() === "FAILED" || item.gptStatus?.toUpperCase()==="NA") ? (
                                                        <button className="flex items-center gap-2 bg-gray-100 text-gray-700 px-4 py-2 rounded hover:bg-gray-200 text-sm font-medium min-w-[156px]" onClick={() => handleChange("openMediaViewModal", item)} >
                                                            <ClipboardList size={16} />
                                                            View Report
                                                        </button>
                                                    ) : (
                                                        <button className="flex items-center gap-2 bg-[var(--primary-color)] text-white px-4 py-2 rounded text-sm font-medium min-w-[156px]" onClick={() => handleChange("uploadReport", item)}>
                                                            <ClipboardPlus size={16} />
                                                            Upload Report
                                                        </button>
                                                    )
                                                ) : (
                                                    item[tableData.key] || "NA"
                                                )}
                                            </td>
                                        ))}
                                    </tr>
                                ))}
                            </tbody>
                        </table>
                    </div>
                </div>
            )}
            {selectedModal && (
                <ParentModal
                    getParentChildProps={getParentChildProps()}
                    childComponent={getChildComponent()}
                    closeModal={() => {
                        setSelectedModal(false)
                        setTrfModalData({})
                    }}
                />
            )}
        </div>
    );
};

export default TRFListsEmail;